import { Component, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { HomeHeaderPreviewComponent } from '../home-header-preview/home-header-preview.component';
import { HomeStepperComponent } from '../home-stepper/home-stepper.component';

@Component({
  selector: 'app-home-container',
  standalone: true,
  imports: [
    ButtonModule,
    HomeHeaderPreviewComponent,
  ],
  templateUrl: './home-container.component.html',
  styleUrl: './home-container.component.scss'
})
export class HomeContainerComponent {
}
